import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
const _excluded = ["accountsPayableGlAccountExternalId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { Typography, Button, Autocomplete, TextField, Grid, Accordion, AccordionDetails, AccordionSummary,
// Note: hided until we develop full implementation of sub meter solution instead of interim
// ToggleButtonGroup,
// ToggleButton,
// MenuItem,
IconButton } from '@mui/material';
import { Icon, InputWithIcon,
// Note: hided until we develop full implementation of sub meter solution instead of interim
// SelectMenu,
toast, BackdropLoader, CONSTANTS, ExpandedTooltip } from '@livable/saas-react-components';
import BillFrequencyModal from './BillFrequencyModal';
import AllocationMethodModal from './AllocationMethodModal';
import VacantUnitBills from './VacantUnitBills';
import CADModal from './CADModal';
import { ListItem } from './UtilityAccordion/listItem';
import { UtilitiesAutocomplete } from './UtilitiesAutocomplete';
// NOTE: Hidden Auto billing feature until further development
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { BillingAutomationSetup } from './BillingAutomationSetup';
import useBillingTemplateModalContentStyles from './styles';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { getRequiredTextMessage } from 'src/utils/formValidation';
import { ALLOCATION_METHOD, BILL_FREQUENCY_NAME, VACANT_UNIT_ALLOCATIONS_TO_PAID_BY, VACANT_UNIT_USAGE, VACANT_UNIT_USAGE_TO_TRANSLATE } from 'src/constants/utilities';
import GLModal from './GLModal';
import { toJS } from 'mobx';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { UtilityCredentialSlot } from 'src/components/property/UtilityPortalCredentials/UtilityCredentialSlot';
import { EMPTY_PENDING_CREDENTIAL } from 'src/components/property/UtilityPortalCredentials/PendingCredentialFields';
import { savePendingCredential } from 'src/components/property/UtilityPortalCredentials/savePendingCredential';
import { isScraperSupported } from 'src/components/property/UtilityPortalCredentials/credentialStatus';
import { currentCompanyId } from 'src/components/property/UtilityPortalCredentials/currentCompanyId';

/** Backend may send 0.55 (decimal) or 55 (percentage). Returns integer 0-100 for display. */
function formatVacantUnitUsageLimitPercent(value) {
  const n = Number(value !== null && value !== void 0 ? value : 0);
  if (Number.isNaN(n)) return 0;
  return n <= 1 && n > 0 ? Math.round(n * 100) : Math.round(n);
}
export const BillingTemplateModalContent = observer(_ref => {
  var _store$homeDashboardS, _propertyUtility$prov7, _propertyUtility$prov8, _propertyUtility$prov9, _propertyUtility$util5, _store$homeDashboardS20;
  let propertyUtility = _ref.propertyUtility,
    isEditing = _ref.isEditing,
    handleClose = _ref.handleClose;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles({
    modalHasNoMargin: true,
    modalHasNoPadding: true
  });
  const classes = useBillingTemplateModalContentStyles();

  // Note: hided until we develop full implementation of sub meter solution instead of interim
  // const [unitOfMeasure, setUnitOfMeasure] = useState('gal');

  // const handleUnitOfMeasureChange = event => {
  //   if (event.target.value) setUnitOfMeasure(event.target.value);
  // };
  const _useState = useState('RUBS'),
    _useState2 = _slicedToArray(_useState, 2),
    billingMethodType = _useState2[0],
    setBillingMethodType = _useState2[1];
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    searchResultItems = _useState6[0],
    setSearchResultItems = _useState6[1];
  let searchUtilityProvidersHandler;
  const searchUtilityProviders = async (event, value) => {
    if (value && value.trim().length > 0) {
      if (searchUtilityProvidersHandler) {
        setSearchResultItems([]);
        clearTimeout(searchUtilityProvidersHandler);
      }
      searchUtilityProvidersHandler = setTimeout(() => store.utilityProviders.searchUtilityProvidersAsync.run(value).then(resp => {
        setSearchResultItems([{
          id: 'createCustomProviderId',
          key: 'createCustomProviderKey',
          label: value + ' (add new provider)',
          inputName: value
        }, ...resp.response.map(item => {
          return _objectSpread(_objectSpread({}, item), {}, {
            id: item.key,
            key: item.key,
            label: item.value
          });
        })]);
      }), 350);
    } else {
      if (searchUtilityProvidersHandler) clearTimeout(searchUtilityProvidersHandler);
    }
    setSearchResultItems([{
      id: 'createCustomProviderId',
      key: 'createCustomProviderKey',
      label: value + ' (add new provider)',
      inputName: value
    }]);
  };

  // Utility portal credentials. Staff-only: the endpoints behind this are Permissions.AdminOrHigher,
  // so a customer rendering it anyway would only collect 403s. Hidden rather than disabled because
  // there is nothing useful a customer could do with it yet.
  const isLivableStaff = store.account.userProfile.isUserLivableStaff;
  const isNewTemplate = propertyUtility.propertyUtilityId === 'NEW_TEMPLATE';
  const propertyUtilityId = isNewTemplate ? null : propertyUtility.propertyUtilityId;
  const propertyId = (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id;
  // companyId is the selected company in local storage - the same source store.admin reads. An
  // impersonating admin therefore writes against the company they are acting as, which is the intent.
  const companyId = currentCompanyId();
  const isScraperSupportedProvider = isScraperSupported(propertyUtility.provider);
  // No utility type is recorded from this modal. Its utilityTypes carry the provider-scoped type
  // id, and the backend resolves that to a different generic id when it writes
  // PropertyUtilities.UtilityId, so anything sent from here would disagree with the utility it
  // claims to describe. Verified on dev. PropertyUtilityId is the load-bearing scope and is exact;
  // on edit the stored value is passed straight back so a correct one is never overwritten.
  const pendingCredentialRef = useRef(_objectSpread({}, EMPTY_PENDING_CREDENTIAL));
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    utilityCredential = _useState8[0],
    setUtilityCredential = _useState8[1];
  const loadCredential = async () => {
    if (!isLivableStaff || !propertyUtilityId) return;
    try {
      const resp = await store.admin.getUtilityCredentialsAsync.run({
        companyId,
        propertyId,
        propertyUtilityId
      });
      const rows = (resp === null || resp === void 0 ? void 0 : resp.response) || resp;
      setUtilityCredential(Array.isArray(rows) ? rows[0] || null : null);
    } catch (error) {
      // Never block the billing template on the credential lookup - the template is the primary
      // job of this modal and must stay editable if the credential service is unavailable.
      setUtilityCredential(null);
    }
  };
  useEffect(() => {
    loadCredential();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLivableStaff, propertyUtilityId]);
  const _useState9 = useState(propertyUtility.provider.isCustom || false),
    _useState0 = _slicedToArray(_useState9, 2),
    isCustomProviderMode = _useState0[0],
    setIsCustomProviderMode = _useState0[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [customProviderName, setCustomProviderName] = useState(propertyUtility.provider.utilityProviderName || '');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [customProviderWebsite, setCustomProviderWebsite] = useState(propertyUtility.provider.website || '');

  const GetBillingSettingsList = observer(() => {
    var _store$homeDashboardS2, _store$homeDashboardS3, _propertyUtility$util, _store$homeDashboardS4, _store$homeDashboardS5, _propertyUtility$util2, _store$homeDashboardS6, _propertyUtility$util3, _store$homeDashboardS7, _propertyUtility$util4;
    const list = [
    // NOTE: Hidden Auto billing feature until further development
    // {
    //   title: t('add_new_property_flow.auto_billing'),
    //   id: `UtilityAccordion_auto_billing_id`,
    //   key: `UtilityAccordion_auto_billing_key_${propertyUtility?.provider?.isAppAutomationEnabled}`,
    //   value: 'inactive',
    //   iconType: 'paper-dollar',
    //   isActive: propertyUtility?.provider?.isAppAutomationEnabled,
    //   action: (
    //     <BillingAutomationSetup
    //       customTrigger={
    //         <Button
    //           variant="actionButton"
    //           size="small"
    //           disabled={!propertyUtility?.provider?.isAppAutomationEnabled}
    //         >
    //           {t('add_new_property_flow.begin_activation')}
    //         </Button>
    //       }
    //       isEdit={isEditing}
    //       billingTemplate={propertyUtility}
    //     />
    //   ),
    // },
    {
      title: t('add_new_property_flow.bill_frequency'),
      id: "UtilityAccordion_bill_frequency_id",
      key: "UtilityAccordion_bill_frequency_key_".concat(propertyUtility.billFrequencyType),
      value: BILL_FREQUENCY_NAME[propertyUtility.billFrequencyType],
      isActive: true,
      isDefault: true,
      action: /*#__PURE__*/React.createElement(BillFrequencyModal, {
        propertyUtility: propertyUtility,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.allocation_method'),
      id: "UtilityAccordion_allocation_method_id",
      key: "UtilityAccordion_allocation_method_key_".concat(propertyUtility.allocationMethod),
      value: CONSTANTS.ALLOCATION_METHODS[propertyUtility.allocationMethod] + "".concat((propertyUtility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || propertyUtility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.propertyBuildingSquare) === 0 ? ' (Error: Property Sq. footage not defined!)' : ''),
      isDefault: ((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.getUtilityInfoById(propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util = propertyUtility.utilityTypes[0]) === null || _propertyUtility$util === void 0 ? void 0 : _propertyUtility$util.utilityTypeId)) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.defaultAllocationMethod) === propertyUtility.allocationMethod,
      isActive: true,
      isError: (propertyUtility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || propertyUtility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.propertyBuildingSquare) === 0,
      action: /*#__PURE__*/React.createElement(AllocationMethodModal, {
        propertyUtility: propertyUtility,
        billingMethod: billingMethodType,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.handling_vacant_unit'),
      id: "UtilityAccordion_handling_vacant_unit_id",
      key: "UtilityAccordion_handling_vacant_unit_key_".concat(propertyUtility.vacantUnitUsage),
      value: "".concat(t(VACANT_UNIT_USAGE_TO_TRANSLATE[propertyUtility.vacantUnitUsage])).concat(propertyUtility.vacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? " (".concat(formatVacantUnitUsageLimitPercent(propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.vacantUnitUsageLimit), "%)") : ''),
      isDefault: ((_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.getUtilityInfoById(propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util2 = propertyUtility.utilityTypes[0]) === null || _propertyUtility$util2 === void 0 ? void 0 : _propertyUtility$util2.utilityTypeId)) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.defaultVacantUnitUsage) === propertyUtility.vacantUnitUsage,
      isActive: true,
      action: /*#__PURE__*/React.createElement(VacantUnitBills, {
        propertyUtility: propertyUtility,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.common_area_deduction'),
      id: "UtilityAccordion_common_area_deduction_id",
      key: "UtilityAccordion_common_area_deduction_key_".concat(propertyUtility.commonAreaDeduction),
      isDefault: (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS6 !== void 0 && (_store$homeDashboardS6 = _store$homeDashboardS6.getUtilityInfoById(propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util3 = propertyUtility.utilityTypes[0]) === null || _propertyUtility$util3 === void 0 ? void 0 : _propertyUtility$util3.utilityTypeId)) !== null && _store$homeDashboardS6 !== void 0 && _store$homeDashboardS6.cad ? propertyUtility.commonAreaDeduction === 5 : propertyUtility.commonAreaDeduction === 0,
      isActive: true,
      value: propertyUtility.commonAreaDeduction + '%',
      // isError: true, // NOTE: TBD if needed
      // customMode: customMode,
      action: /*#__PURE__*/React.createElement(CADModal, {
        propertyUtility: propertyUtility,
        isEdit: isEditing,
        goodWillDeductionValue: propertyUtility.goodWillDeduction,
        defaultCadEnabled: (_store$homeDashboardS7 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS7 === void 0 || (_store$homeDashboardS7 = _store$homeDashboardS7.getUtilityInfoById(propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util4 = propertyUtility.utilityTypes[0]) === null || _propertyUtility$util4 === void 0 ? void 0 : _propertyUtility$util4.utilityTypeId)) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.cad
      })
    }, {
      title: t('general.goodwill_deduction'),
      id: "UtilityAccordion_good_will_deduction_id",
      key: "UtilityAccordion_good_will_deduction_key",
      value: propertyUtility.goodWillDeduction,
      isDefault: propertyUtility.goodWillDeduction === 5,
      utilityCAD: propertyUtility.commonAreaDeduction,
      onChangeCallback: val => propertyUtility.setGoodWillDeduction(Number(val)),
      submitCallback: () => {
        // console.log('itemSubmitCallback');
      },
      isGWD: true,
      isActive: true,
      isEditable: !isEditing,
      showInfo: isEditing,
      infoComponent: /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "info",
        title: t('add_new_property_flow.update_gwd_info'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        state: "info",
        type: "question"
      })))
    }];
    if (billingMethodType !== 'RUBS') {
      list.unshift({
        title: t('Property meter ID'),
        id: "UtilityAccordion_property_meter_id",
        key: "UtilityAccordion_property_meter_key_",
        value: 'Not provided',
        warningValue: true,
        isActive: false,
        action: /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          size: "small",
          disabled: true,
          'custom-attribute': '615-new-billing-module'
        }, t('Provide ID'))
      }, {
        title: t('Unit meter IDs'),
        id: "UtilityAccordion_unit_meter_id",
        key: "UtilityAccordion_unit_meter_key_",
        value: '0/10 provided',
        warningValue: true,
        isActive: false,
        action: /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          size: "small",
          disabled: true,
          'custom-attribute': '616-new-billing-module'
        }, t('Provide ID'))
      }, {
        title: t('Charge variance alert'),
        id: "UtilityAccordion_charge_variance_alert_id",
        key: "UtilityAccordion_charge_variance_alert_key_",
        value: '20%',
        isActive: true,
        isEditable: true
      });
    }
    if (store.company.companyFeatureStore.isAppfolio) {
      var _store$homeDashboardS8, _store$homeDashboardS9, _store$homeDashboardS0;
      const defaultGl = (_store$homeDashboardS8 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS8 === void 0 || (_store$homeDashboardS8 = _store$homeDashboardS8.details) === null || _store$homeDashboardS8 === void 0 || (_store$homeDashboardS8 = _store$homeDashboardS8.glCodeSetup) === null || _store$homeDashboardS8 === void 0 ? void 0 : _store$homeDashboardS8.glAccountExternalId;
      const customGl = (_store$homeDashboardS9 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.details) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.glCodeSetup) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.utilityGlAccounts) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.find(ci => ci.propertyUtilityLivableId === (propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId))) === null || _store$homeDashboardS9 === void 0 ? void 0 : _store$homeDashboardS9.glAccountExternalId;
      list.push({
        title: t('Resident Charges GL Account (Income)'),
        id: "UtilityAccordion_gl_id",
        key: "UtilityAccordion_gl_key_".concat(propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId),
        isDefault: !customGl || defaultGl === customGl,
        isActive: true,
        value: (_store$homeDashboardS0 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS0 === void 0 || (_store$homeDashboardS0 = _store$homeDashboardS0.details) === null || _store$homeDashboardS0 === void 0 ? void 0 : _store$homeDashboardS0.glCodeSetup.getGlNameByCode(customGl ? customGl : defaultGl),
        action: /*#__PURE__*/React.createElement(GLModal, {
          propertyUtility: propertyUtility,
          savedValue: customGl ? customGl : defaultGl,
          onSaveAndClose: async glId => {
            var _store$homeDashboardS1;
            (_store$homeDashboardS1 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.details) === null || _store$homeDashboardS1 === void 0 || _store$homeDashboardS1.glCodeSetup.updateUtilityGlAccounts(propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId, glId);
          },
          isEdit: isEditing
        })
      });
      if (store.account.featureFlagsStore.getIsGlCodesEnabled) {
        var _store$homeDashboardS10, _store$homeDashboardS11, _store$homeDashboardS12;
        const defaultPayableGl = (_store$homeDashboardS10 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.details) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.glCodeSetup) === null || _store$homeDashboardS10 === void 0 ? void 0 : _store$homeDashboardS10.accountsPayableGlAccountExternalId;
        const customPayableGl = (_store$homeDashboardS11 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS11 === void 0 || (_store$homeDashboardS11 = _store$homeDashboardS11.details) === null || _store$homeDashboardS11 === void 0 || (_store$homeDashboardS11 = _store$homeDashboardS11.glCodeSetup) === null || _store$homeDashboardS11 === void 0 || (_store$homeDashboardS11 = _store$homeDashboardS11.utilityGlAccounts) === null || _store$homeDashboardS11 === void 0 || (_store$homeDashboardS11 = _store$homeDashboardS11.find(ci => ci.propertyUtilityLivableId === (propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId))) === null || _store$homeDashboardS11 === void 0 ? void 0 : _store$homeDashboardS11.accountsPayableGlAccountExternalId;
        list.push({
          title: t('Accounts Payable GL Account (Expense)'),
          id: "UtilityAccordion_payable_gl_id",
          key: "UtilityAccordion_payable_gl_key_".concat(propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId),
          isDefault: !customPayableGl || defaultPayableGl === customPayableGl,
          isActive: true,
          value: (_store$homeDashboardS12 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS12 === void 0 || (_store$homeDashboardS12 = _store$homeDashboardS12.details) === null || _store$homeDashboardS12 === void 0 ? void 0 : _store$homeDashboardS12.glCodeSetup.getGlNameByCode(customPayableGl ? customPayableGl : defaultPayableGl),
          action: /*#__PURE__*/React.createElement(GLModal, {
            isPayable: true,
            propertyUtility: propertyUtility,
            savedValue: customPayableGl ? customPayableGl : defaultPayableGl,
            onSaveAndClose: async glId => {
              var _store$homeDashboardS13;
              (_store$homeDashboardS13 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS13 === void 0 || (_store$homeDashboardS13 = _store$homeDashboardS13.details) === null || _store$homeDashboardS13 === void 0 || _store$homeDashboardS13.glCodeSetup.updateUtilityAccountsPayableGlAccounts(propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId, glId);
            },
            isEdit: isEditing
          })
        });
      }
    }
    return list.map(item => /*#__PURE__*/React.createElement(ListItem, {
      key: !isEditing ? "List_ITEM_NEW_".concat(item.key) : "List_ITEM_".concat(item.key),
      item: item
    }));
  });
  const _useState1 = useState(undefined),
    _useState10 = _slicedToArray(_useState1, 2),
    newSelectedProviderData = _useState10[0],
    setNewSelectedProviderData = _useState10[1];
  const configureBillingTemplateBySelectedProvider = async (event, value) => {
    clearTimeout(searchUtilityProvidersHandler);
    setSearchResultItems([]);
    if (value && (value === null || value === void 0 ? void 0 : value.id) === 'createCustomProviderId') {
      // toggle custom provider create
      setIsCustomProviderMode(true);
      // setCustomProviderName(value.inputName);
      if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
        propertyUtility.configureProviderModelForNewTemplate({
          name: value.inputName,
          isCustom: true,
          utilities: null
        });
        propertyUtility.removeUtilityType('all');
      }
      return;
    }
    if (value && (value !== null && value !== void 0 && value.id || value !== null && value !== void 0 && value.utilityProviderId)) {
      await Promise.all([store.utilityProviders.getUtilityProvidersListDataAsync.run({
        utilityProviderIds: [value.id || value.utilityProviderId]
      }).then(async resp => {
        if (resp && resp.isSuccessful) {
          store.addNewProperty.utilitiesSetupV2.setNewUtilityConfiguration(singleElementOfArray(resp.response));
          setNewSelectedProviderData(_objectSpread({}, singleElementOfArray(resp.response)));
          propertyUtility.configureProviderModelForNewTemplate(singleElementOfArray(resp.response));
          if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
            propertyUtility.removeUtilityType('all');
          }
        }
      })]);
    }
  };
  const createUpdateCustomUtilityTemplate = async () => {
    const createEditCustomProvider = async _ref2 => {
      let isEditProvider = _ref2.isEditProvider,
        name = _ref2.name,
        website = _ref2.website,
        providerId = _ref2.providerId,
        genericUtilityTypesToAssign = _ref2.genericUtilityTypesToAssign;
      if (isEditProvider) {
        await store.utilityProviders.editCustomUtilityProvidersAsync.run({
          name,
          website,
          providerId,
          propertyId: store.homeDashboardStore.getCurrentProperty.id
        }, [propertyUtility.propertyUtilityId]);
        return providerId;
      } else {
        const _await$store$utilityP = await store.utilityProviders.addCustomUtilityProvidersV2Async.run({
            name,
            website,
            propertyId: store.homeDashboardStore.getCurrentProperty.id,
            utilityTypeIds: genericUtilityTypesToAssign
          }, [propertyUtility.propertyUtilityId]),
          createdProviderId = _await$store$utilityP.response,
          isSuccessful = _await$store$utilityP.isSuccessful;
        if (isSuccessful) {
          return createdProviderId;
        }
      }
    };
    const createCustomUtilitiesAndApplyToProvider = async _ref3 => {
      let utilityName = _ref3.utilityName,
        allocationMethod = _ref3.allocationMethod,
        vacantUnitUsage = _ref3.vacantUnitUsage,
        vacantUnitAllocation = _ref3.vacantUnitAllocation,
        commonAreaDeduction = _ref3.commonAreaDeduction,
        providerIdToAttach = _ref3.providerIdToAttach;
      return store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.run({
        name: utilityName,
        defaultAllocationMethod: allocationMethod,
        defaultVacantUnitUsage: vacantUnitUsage,
        paidBy: VACANT_UNIT_ALLOCATIONS_TO_PAID_BY[vacantUnitAllocation],
        cad: !!commonAreaDeduction,
        utilityProviderId: providerIdToAttach
      }, [propertyUtility.propertyUtilityId]);
    };
    let customProviderId;
    if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
      customProviderId = await createEditCustomProvider({
        isEditProvider: false,
        name: propertyUtility.provider.utilityProviderName,
        website: propertyUtility.provider.website,
        providerId: undefined,
        genericUtilityTypesToAssign: propertyUtility.provider.utilities.map(i => i.utilityTypeId)
      });
      propertyUtility.provider.setUtilityProviderId(customProviderId);
      for (let customUt of propertyUtility.utilityTypes.filter(i => i === null || i === void 0 ? void 0 : i.utilityTypeId.startsWith('customUtilityId_'))) {
        const createdCustomUtilitiesResp = await createCustomUtilitiesAndApplyToProvider({
          utilityName: customUt.utilityTypeName,
          allocationMethod: propertyUtility.allocationMethod,
          vacantUnitUsage: propertyUtility.vacantUnitUsage,
          vacantUnitAllocation: propertyUtility.vacantUnitAllocation,
          commonAreaDeduction: propertyUtility.commonAreaDeduction,
          providerIdToAttach: customProviderId
        });
        if (createdCustomUtilitiesResp !== null && createdCustomUtilitiesResp !== void 0 && createdCustomUtilitiesResp.isSuccessful) {
          propertyUtility.updateUtilityTypeIdForNewCustomUtilityType({
            searchUtilityTypeId: customUt.utilityTypeId,
            utilityTypeId: createdCustomUtilitiesResp.response.utilityTypeId
          });
        }
      }
    } else {
      var _propertyUtility$prov;
      await createEditCustomProvider({
        isEditProvider: true,
        name: propertyUtility.provider.utilityProviderName,
        website: propertyUtility.provider.website,
        providerId: (_propertyUtility$prov = propertyUtility.provider) === null || _propertyUtility$prov === void 0 ? void 0 : _propertyUtility$prov.utilityProviderId
      });
      for (let customUt of propertyUtility.utilityTypes.filter(i => i === null || i === void 0 ? void 0 : i.utilityTypeId.startsWith('customUtilityId_'))) {
        var _propertyUtility$prov2;
        const createdCustomUtilitiesResp = await createCustomUtilitiesAndApplyToProvider({
          utilityName: customUt.utilityTypeName,
          allocationMethod: propertyUtility.allocationMethod,
          vacantUnitUsage: propertyUtility.vacantUnitUsage,
          vacantUnitAllocation: propertyUtility.vacantUnitAllocation,
          commonAreaDeduction: propertyUtility.commonAreaDeduction,
          providerIdToAttach: (_propertyUtility$prov2 = propertyUtility.provider) === null || _propertyUtility$prov2 === void 0 ? void 0 : _propertyUtility$prov2.utilityProviderId
        });
        if (createdCustomUtilitiesResp !== null && createdCustomUtilitiesResp !== void 0 && createdCustomUtilitiesResp.isSuccessful) {
          propertyUtility.updateUtilityTypeIdForNewCustomUtilityType({
            searchUtilityTypeId: customUt.utilityTypeId,
            utilityTypeId: createdCustomUtilitiesResp.response.utilityTypeId
          });
        }
      }
    }
    return {
      customProviderId
    };
  };
  const finalizeSavingAndFetchUpdates = unicIdsForReq => {
    store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchBillingTemplates({
      forceUpdate: true,
      useUnicInProgress: false,
      customUnicInProgress: unicIdsForReq
    });
    store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchPropertyUtilityProviders({
      useUnicInProgress: false,
      customUnicInProgress: unicIdsForReq
    });
  };
  const updateUtilityGlCodes = async () => {
    var _store$homeDashboardS14;
    const glCodeSetup = (_store$homeDashboardS14 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS14 === void 0 || (_store$homeDashboardS14 = _store$homeDashboardS14.details) === null || _store$homeDashboardS14 === void 0 ? void 0 : _store$homeDashboardS14.glCodeSetup;
    if (!glCodeSetup || glCodeSetup.utilityGlAccountsPatchSemanticallyEqual()) {
      return;
    }
    let patchValue = glCodeSetup.getUtilityGlAccountsValueForPatch();
    if (!patchValue.length) {
      patchValue = toJS(glCodeSetup.utilityGlAccounts);
    }
    if (!patchValue.length) {
      return;
    }
    if (!store.account.featureFlagsStore.getIsGlCodesEnabled) {
      patchValue = patchValue.map(_ref4 => {
        let accountsPayableGlAccountExternalId = _ref4.accountsPayableGlAccountExternalId,
          rest = _objectWithoutProperties(_ref4, _excluded);
        return rest;
      });
    }
    patchValue = glCodeSetup.normalizeUtilityGlAccountsForPatch(patchValue);
    await store.credentials.patchAppfolioPropertiesAsync.run({
      properties: [{
        propertyLivableId: store.homeDashboardStore.getCurrentProperty.id,
        utilityGlAccounts: {
          value: patchValue
        }
      }]
    });
    glCodeSetup.handleUtilityGlAccountsSave();
  };
  const createUpdateUtilityTemplate = async () => {
    if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
      var _store$homeDashboardS15, _propertyUtility$prov3, _store$homeDashboardS17, _propertyUtility$prov5, _store$homeDashboardS18;
      // NOTE: Adding
      if (((_store$homeDashboardS15 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS15 === void 0 || (_store$homeDashboardS15 = _store$homeDashboardS15.selectedPropertyDetails()) === null || _store$homeDashboardS15 === void 0 || (_store$homeDashboardS15 = _store$homeDashboardS15.details) === null || _store$homeDashboardS15 === void 0 ? void 0 : _store$homeDashboardS15.getPropertyUtilityProvider((_propertyUtility$prov3 = propertyUtility.provider) === null || _propertyUtility$prov3 === void 0 ? void 0 : _propertyUtility$prov3.utilityProviderId)) === null) {
        var _store$homeDashboardS16, _propertyUtility$prov4;
        const addPropertyUtilityProviderAsyncResp = await store.properties.addPropertyUtilityProviderAsync.run({
          propertyId: (_store$homeDashboardS16 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS16 === void 0 ? void 0 : _store$homeDashboardS16.id,
          utilityProviderId: (_propertyUtility$prov4 = propertyUtility.provider) === null || _propertyUtility$prov4 === void 0 ? void 0 : _propertyUtility$prov4.utilityProviderId
        }, [propertyUtility.propertyUtilityId]);
        if (addPropertyUtilityProviderAsyncResp !== null && addPropertyUtilityProviderAsyncResp !== void 0 && addPropertyUtilityProviderAsyncResp.isSuccessful) {
          console.log('addPropertyUtilityProviderAsyncResp', addPropertyUtilityProviderAsyncResp.response);
        }
      }
      return store.propertyUtility.createPropertyUtilitiesAsync.run({
        propertyId: (_store$homeDashboardS17 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS17 === void 0 ? void 0 : _store$homeDashboardS17.id,
        propertyUtilities: [_objectSpread(_objectSpread({}, propertyUtility), {}, {
          utilityProviderId: (_propertyUtility$prov5 = propertyUtility.provider) === null || _propertyUtility$prov5 === void 0 ? void 0 : _propertyUtility$prov5.utilityProviderId,
          buildingIds: [(_store$homeDashboardS18 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS18 === void 0 ? void 0 : _store$homeDashboardS18.propertyBuildingId],
          utilityTypeIds: propertyUtility.utilityTypes.map(i => i.utilityTypeId),
          vacantUnitUsageLimit: propertyUtility.vacantUnitUsageLimit / 100,
          customCommonAreaDeduction: propertyUtility.commonAreaDeduction
        })]
      }, [propertyUtility.propertyUtilityId]).then(async () => {
        await updateUtilityGlCodes();
        toast('success', {
          body: ['Billing template added!']
        });
        finalizeSavingAndFetchUpdates([propertyUtility.propertyUtilityId]);
      });
    } else {
      var _store$homeDashboardS19;
      // NOTE: Editing
      return store.propertyUtility.updatePropertyUtilitiesAsync.run([_objectSpread(_objectSpread({}, propertyUtility), {}, {
        buildingIds: [(_store$homeDashboardS19 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS19 === void 0 ? void 0 : _store$homeDashboardS19.propertyBuildingId],
        utilityTypeIds: propertyUtility.utilityTypes.map(i => i.utilityTypeId),
        vacantUnitUsageLimit: propertyUtility.vacantUnitUsageLimit / 100,
        customCommonAreaDeduction: propertyUtility.commonAreaDeduction
      })], [propertyUtility.propertyUtilityId]).then(async () => {
        await updateUtilityGlCodes();
        toast('success', {
          body: ['Billing template updated!']
        });
        finalizeSavingAndFetchUpdates([propertyUtility.propertyUtilityId]);
      });
    }
  };

  // Note: hided until we develop full implementation of sub meter solution instead of interim
  // const handleChangeMethodType = (event, value) => {
  //   event.preventDefault();
  //   if (value === 'SubMeter') {
  //     propertyUtility.setAllocationMethod(ALLOCATION_METHOD.BySubmeter);
  //   }
  //   setBillingMethodType(value);
  // };

  const handleTemplateSave = () => {
    // Snapshot the secret and drop it from the form immediately: the modal closes below while the
    // save is still in flight.
    const pendingCredential = pendingCredentialRef.current;
    pendingCredentialRef.current = _objectSpread({}, EMPTY_PENDING_CREDENTIAL);
    const wasNewTemplate = isNewTemplate;

    // After the utility exists, never before - the credential row must reference a real
    // propertyUtilityId. A failure here is reported but does not undo the utility. Provider and
    // type are read here rather than captured earlier because a custom provider only gets its id
    // during the save above.
    const saveCredentialAfterUtilityExists = () => {
      var _propertyUtility$prov6;
      if (!wasNewTemplate || !isLivableStaff) return undefined;
      return savePendingCredential({
        store,
        pending: pendingCredential,
        companyId,
        propertyId,
        utilityProviderId: (_propertyUtility$prov6 = propertyUtility.provider) === null || _propertyUtility$prov6 === void 0 ? void 0 : _propertyUtility$prov6.utilityProviderId
      });
    };
    if (isCustomProviderMode) {
      createUpdateCustomUtilityTemplate().then(() => {
        createUpdateUtilityTemplate().then(saveCredentialAfterUtilityExists);
      });
    } else {
      createUpdateUtilityTemplate().then(saveCredentialAfterUtilityExists);
    }
    handleClose();
  };
  const getModalIsLoading = () => {
    var _store$properties$add, _store$propertyUtilit, _store$propertyUtilit2;
    return ((_store$properties$add = store.properties.addPropertyUtilityProviderAsync) === null || _store$properties$add === void 0 || (_store$properties$add = _store$properties$add.inProgressUnicIds) === null || _store$properties$add === void 0 ? void 0 : _store$properties$add.includes(propertyUtility.propertyUtilityId)) || ((_store$propertyUtilit = store.propertyUtility.createPropertyUtilitiesAsync) === null || _store$propertyUtilit === void 0 || (_store$propertyUtilit = _store$propertyUtilit.inProgressUnicIds) === null || _store$propertyUtilit === void 0 ? void 0 : _store$propertyUtilit.includes(propertyUtility.propertyUtilityId)) || ((_store$propertyUtilit2 = store.propertyUtility.updatePropertyUtilitiesAsync) === null || _store$propertyUtilit2 === void 0 || (_store$propertyUtilit2 = _store$propertyUtilit2.inProgressUnicIds) === null || _store$propertyUtilit2 === void 0 ? void 0 : _store$propertyUtilit2.includes(propertyUtility.propertyUtilityId));
  };
  useEffect(() => {
    setBillingMethodType(propertyUtility.allocationMethod === ALLOCATION_METHOD.BySubmeter ? 'SubMeter' : 'RUBS');
  }, [propertyUtility.allocationMethod]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, !isEditing && !isCustomProviderMode ? t('add_new_property_flow.find_the_provider') : t('add_new_property_flow.provider')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, !isEditing && !isCustomProviderMode ? t('add_new_property_flow.find_a_provider_of_the_utilities_that_are_mentioned_in_your_bill') : t('add_new_property_flow.provider_description')), !isCustomProviderMode && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    autoFocus: true,
    id: "provider-selector",
    key: "key-provider-selector",
    variant: "withIcon",
    disablePortal: true,
    loading: store.utilityProviders.searchUtilityProvidersAsync.inProgress,
    disabled: isEditing,
    clearIcon: true,
    popupIcon: null,
    value: propertyUtility.provider.utilityProviderName || (newSelectedProviderData === null || newSelectedProviderData === void 0 ? void 0 : newSelectedProviderData.name),
    options: searchResultItems,
    onInputChange: searchUtilityProviders,
    onChange: configureBillingTemplateBySelectedProvider,
    renderInput: params => /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      })
    }, /*#__PURE__*/React.createElement(TextField, _extends({
      autoFocus: true
    }, params, {
      id: "provider-selector",
      label: t('add_new_property_flow.provider_search')
    })))
  })), isCustomProviderMode && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "name",
    name: "name",
    label: t('add_new_property_flow.provider_name'),
    variant: "outlined",
    fullWidth: true,
    value: propertyUtility.provider.utilityProviderName,
    onChange: e => {
      propertyUtility.provider.setUtilityProviderName(e.target.value);
    },
    error: !propertyUtility.provider.utilityProviderName && !propertyUtility.provider.utilityProviderName.length,
    helperText: !propertyUtility.provider.utilityProviderName && !propertyUtility.provider.utilityProviderName.length && getRequiredTextMessage('Provide Name')
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('add_new_property_flow.provider_website'),
    id: "website",
    name: "website",
    variant: "outlined",
    fullWidth: true,
    value: propertyUtility.provider.website,
    onChange: e => {
      propertyUtility.provider.setWebsite(e.target.value);
    }
  })))), (!!newSelectedProviderData || isCustomProviderMode || propertyUtility.propertyUtilityId !== 'NEW_TEMPLATE' || propertyUtility.propertyUtilityId === 'NEW_TEMPLATE' && ((_propertyUtility$prov7 = propertyUtility.provider) === null || _propertyUtility$prov7 === void 0 || (_propertyUtility$prov7 = _propertyUtility$prov7.utilities) === null || _propertyUtility$prov7 === void 0 ? void 0 : _propertyUtility$prov7.length)) && /*#__PURE__*/React.createElement(UtilitiesAutocomplete, {
    key: 'SelectedUtilitiesAutocompleteKey',
    id: 'SelectedUtilitiesAutocompleteId',
    propertyUtility: propertyUtility,
    currentProviderDataExt: newSelectedProviderData,
    isCustomProviderMode: isCustomProviderMode
  }), /*#__PURE__*/React.createElement(UtilityCredentialSlot, {
    isLivableStaff: isLivableStaff,
    isScraperSupportedProvider: isScraperSupportedProvider,
    className: classes.xlSection,
    companyId: companyId,
    propertyId: propertyId,
    propertyUtilityId: propertyUtilityId,
    utilityProviderId: (_propertyUtility$prov8 = propertyUtility.provider) === null || _propertyUtility$prov8 === void 0 ? void 0 : _propertyUtility$prov8.utilityProviderId,
    utilityTypeId: utilityCredential === null || utilityCredential === void 0 ? void 0 : utilityCredential.utilityTypeId,
    providerName: (_propertyUtility$prov9 = propertyUtility.provider) === null || _propertyUtility$prov9 === void 0 ? void 0 : _propertyUtility$prov9.utilityProviderName,
    credential: utilityCredential,
    onChanged: loadCredential,
    pendingRef: pendingCredentialRef
  }), ((propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.utilityTypes) && !!(propertyUtility !== null && propertyUtility !== void 0 && propertyUtility.utilityTypes.length) || propertyUtility.propertyUtilityId === 'NEW_TEMPLATE' && (propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.utilityTypes) && !!(propertyUtility !== null && propertyUtility !== void 0 && propertyUtility.utilityTypes.length)) && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.billing_settings')), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    id: "utility-content",
    "aria-controls": "utility-content",
    onClick: () => setIsOpen(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContentTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.default_settings'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.accordionContentIcon, " ").concat(isOpen ? 'open' : '')
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    type: "arrow-line-down"
  })))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBody
  }, /*#__PURE__*/React.createElement(GetBillingSettingsList, null))))))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    disabled: getModalIsLoading(),
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      handleClose();
    },
    'custom-attribute': '617-new-billing-module'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    disabled: getModalIsLoading() || !(propertyUtility !== null && propertyUtility !== void 0 && (_propertyUtility$util5 = propertyUtility.utilityTypes) !== null && _propertyUtility$util5 !== void 0 && _propertyUtility$util5.length) || (propertyUtility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || propertyUtility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS20 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS20 === void 0 ? void 0 : _store$homeDashboardS20.propertyBuildingSquare) === 0 || isCustomProviderMode && !propertyUtility.provider.utilityProviderName && !propertyUtility.provider.utilityProviderName.length,
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      handleTemplateSave();
    },
    'custom-attribute': '618-new-billing-module'
  }, t('Save utility')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: getModalIsLoading()
  }));
});